import { ROOM_IDS, type RoomId } from '@/story/beats';
import type { RoomModuleDefinition } from '@/game/roomModule';
import { OFFICE_ROOM_MODULE } from '@/game/rooms/office';
import { WOOL_SHED_ROOM_MODULE } from '@/game/rooms/woolShed';
import { YARD_DAWN_ROOM_MODULE } from '@/game/rooms/yardDawn';
import { YARD_FAILS_ROOM_MODULE } from '@/game/rooms/yardFails';
import { HILL_ROOM_MODULE } from '@/game/rooms/hill';
import { HEDGEROW_NIGHT_ROOM_MODULE, HEDGEROW_ROOM_MODULE } from '@/game/rooms/hedgerow';
import { YARD_ROOM_MODULE } from '@/game/rooms/yard';
import { SERVICE_ROOM_MODULE } from '@/game/rooms/service';
import { CULL_ROOM_MODULE } from '@/game/rooms/cull';
import { FATTENING_ROOM_MODULE } from '@/game/rooms/fattening';
import { FARROWING_ROOM_MODULE } from '@/game/rooms/farrowing';

export const ROOM_MODULES: readonly RoomModuleDefinition[] = [WOOL_SHED_ROOM_MODULE, OFFICE_ROOM_MODULE, YARD_DAWN_ROOM_MODULE, YARD_FAILS_ROOM_MODULE, HILL_ROOM_MODULE,
  HEDGEROW_ROOM_MODULE, HEDGEROW_NIGHT_ROOM_MODULE, YARD_ROOM_MODULE, SERVICE_ROOM_MODULE, CULL_ROOM_MODULE, FATTENING_ROOM_MODULE, FARROWING_ROOM_MODULE];
const REGISTERED_ROOMS = new Set(ROOM_MODULES.map((module) => module.room));
export const LEGACY_ROOMS: readonly RoomId[] = ROOM_IDS.filter((room) => !REGISTERED_ROOMS.has(room));
export function roomModuleFor(room: RoomId): RoomModuleDefinition | null {
  return ROOM_MODULES.find((entry) => entry.room === room) ?? null;
}
export function validateRoomModuleRegistry(
  list: readonly RoomModuleDefinition[],
  rooms: readonly RoomId[] = ROOM_IDS,
  legacy: readonly RoomId[] = LEGACY_ROOMS,
): void {
  const registered = new Set<RoomId>();
  for (const definition of list) {
    if (registered.has(definition.room)) throw new Error(`room "${definition.room}": duplicate module registration`);
    if (!rooms.includes(definition.room)) throw new Error(`room "${definition.room}": unknown room`);
    if (legacy.includes(definition.room)) throw new Error(`room "${definition.room}": registered but still listed as legacy`);
    registered.add(definition.room);
  }
  // A legacy entry that is not a room, or is listed twice, would let the coverage
  // check below read as more migrated or less migrated than the code is.
  const seenLegacy = new Set<RoomId>();
  for (const room of legacy) {
    if (!rooms.includes(room)) throw new Error(`room "${room}": listed as legacy but not a room`);
    if (seenLegacy.has(room)) throw new Error(`room "${room}": listed as legacy twice`);
    seenLegacy.add(room);
  }
  for (const room of rooms) {
    if (!registered.has(room) && !legacy.includes(room)) throw new Error(`room "${room}": no module registered and not listed as legacy`);
  }
}
validateRoomModuleRegistry(ROOM_MODULES);
